<template>
  <div class="updatamechanicalarm addCommon" style="height: 100%">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{ $t('LanguageLib.DEVICE_INFO') }}</span>
    </div>
    <div class="content">
      <el-form label-width="0px" class="ruleForm">
        <el-button @click="submit('ruleForm')" type="primary" class="searchBtn" :loading="loadingSave">{{$t('LanguageLib.SAVE')}}</el-button>
        <p class="drawerText">{{$t('LanguageLib.Equipment_Number')}}</p>
        <el-form-item>
          <el-input
            style="width: 320px;"
            :placeholder="$t('LanguageLib.PleaseEnter')"
            :maxlength="50"
            v-model="editdata.description"
          >
          </el-input>
        </el-form-item>
        <p class="drawerText">{{$t('LanguageLib.Device_Type')}}</p>
        <el-form-item>
          <el-input
            :disabled="true"
            maxlength="50"
            style="width: 320px;"
            :placeholder="$t('LanguageLib.PleaseEnter')"
            v-model="editdata.deviceType"
          >
          </el-input>
        </el-form-item>
        <p class="drawerText">{{$t('LanguageLib.Device_SN')}}</p>
        <el-form-item>
          <el-input
            :disabled="true"
            maxlength="50"
            style="width: 320px;"
            :placeholder="$t('LanguageLib.PleaseEnter')"
            v-model="editdata.serialNumber"
          >
          </el-input>
        </el-form-item>
        <p class="drawerText">{{$t('LanguageLib.ARM_BRAND')}}</p>
        <el-form-item>
          <el-input
            maxlength="50"
            @keyup.native="btKeyUp"
            style="width: 320px;"
            :placeholder="$t('LanguageLib.PleaseEnter')"
            v-model="editdata.brand"
          >
          </el-input>
        </el-form-item>
        <p class="drawerText">{{$t('LanguageLib.MODEL')}}</p>
        <el-form-item>
          <el-input
            maxlength="50"
            style="width: 320px;"
            :placeholder="$t('LanguageLib.PleaseEnter')"
            v-model="editdata.modelNumber"
          >
          </el-input>
        </el-form-item>
        <p class="drawerText">{{$t('LanguageLib.Installation_POSITION')}}</p>
        <el-input
        style="width: 320px;margin-bottom: 15px;"
          maxlength="200"
          type="textarea"
          :rows="3"
          placeholder=""
          resize="none"
          v-model="editdata.location"
        >
        </el-input>
        <p class="drawerText">{{$t('LanguageLib.CUSTOMER')}}</p>
        <el-form-item>
          <el-input
            maxlength="50"
            style="width: 320px;"
            :placeholder="$t('LanguageLib.PleaseEnter')"
            v-model="editdata.owner"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import devicemanagementApi from '../../api/devicemanagement'
export default {
  name: 'updatamechanicalarm',
  props: ['currentPage', 'pageSize', 'searchText', 'sort', 'sortOrder'],
  data () {
    return {
      editdata: {},
      loadingSave: false // 保存按钮加loding
    }
  },
  created () {
    this.editdata = JSON.parse(this.$commonfun.decodeUrl(this.$route.query.data))
  },
  methods: {
    // 去除组织名称的特殊字符
    btKeyUp (e) {
      e.target.value = e.target.value.replace(/[\\/:：*?？"<>|]/g, '')
    },
    // 返回
    goReturn () {
      this.$router.push('/devicemanagement/mechanicalarm?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&sortOrder=' + this.$route.query.sortOrder + '&fromPath=update')
    },
    // 保存数据
    submit (formName) {
      this.editdata.description = this.$commonfun.trim('tail', this.editdata.description)
      this.editdata.brand = this.$commonfun.trim('tail', this.editdata.brand)
      this.editdata.modelNumber = this.$commonfun.trim('tail', this.editdata.modelNumber)
      this.editdata.location = this.$commonfun.trim('tail', this.editdata.location)
      this.editdata.owner = this.$commonfun.trim('tail', this.editdata.owner)
      devicemanagementApi.EditArm('put', '/api/v4/devices', this.editdata, 'deviceApi')
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.EditSuccess')
          })
          this.$router.push('/devicemanagement/mechanicalarm?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&sortOrder=' + this.$route.query.sortOrder + '&fromPath=update')
          this.loadingSave = false
        })
        .catch(err => {
          this.loadingSave = false
          this.$commonfun.console.log(err)
        })
    }
  }
}
</script>

<style lang="scss">
.updatamechanicalarm{
  .left{
    background: #fff;
    width:  320px;
    float: left;
    height: 100%;
    border-right: 1px solid #f2f2f2;
    .treeBox {
      height: 485px;
    }
  }
  .TeInput input{
    border-right: 0px;
    border-radius: 4px 0 0 4px;
  }
  .return{
    padding-left: 25px;
    position: relative;
    height:50px;
    background:rgba(255,255,255,1);
    line-height: 50px;
    border-bottom: 1px solid #F2F2F2;
    .el-icon-back{
      margin-right: 15px;
      cursor: pointer;
    }
    .border{
      position: absolute;
      height: 37px;
      border-left: 1px solid #f1f1f1;
      display: inline-block;
      top: 5px;
    }
    .title{
      height:25px;
      font-size:18px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(0,0,0,1);
      margin-left: 15px;
    }
  }
  .content::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  .content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    background: #E1E1E1;
  }
  .content::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    border-radius: 5px;
    background: #fff;
  }
  .content{
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    width: 100%;
    height: calc( 100% - 50px);
    overflow-y: auto;
    padding-left: 100px;
    padding-top: 15px;
    .drawerText{
      margin-bottom: 5px;
      height:16px;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(77,77,77,1);
      line-height:16px;
    }
  }
  // 修改按钮样式
  .el-button--primary{
    background-color: #3BC6B9;
    border-color: #3BC6B9;
    height: 30px;
    padding: 7px 20px;
    margin-bottom: 15px;
  }
  .colorRed{
    color: red;
  }
  // 组织树视图
  .el-dialog{
    overflow: hidden;
  }
  .el-textarea__inner{
    font: 400 14px Arial;
  }
  .el-input .is-disabled{
    color: #2c3e50;
  }
}
</style>
